import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";
import { BindedView } from "../utilities";
import { ComponentView } from "../../../uiPatterns/component";

export class ComponentBridgePrototype extends HtmlBridgePrototype{

    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new ComponentHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

export class ComponentTagMappings{
    private static mapping:Map<string,(parent:ViewModel)=>ViewModel>=new Map<string,(parent:ViewModel)=>ViewModel>();

    public static register(tag:string,factory:(parent:ViewModel)=>ViewModel){
        this.mapping.set(tag,factory);
    }
    public static getComponent(tag:string):(parent:ViewModel)=>ViewModel{
        return this.mapping.get(tag);
    }
}
class ComponentHtmlBridge extends HtmlBridge{
    
    private binding:IBinding;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    private parentAttributes:NamedNodeMap;
    private bindedView:BindedView;
    private mainElement:Element;
    private prototype:ComponentBridgePrototype;
    constructor(prototype:ComponentBridgePrototype) {
        super();

        this.bindingPrototype = prototype.binding;
        this.prototype = prototype;
    }
    
    public set viewModel(v: ViewModel) { 
        this._viewModel = v;

        this.bindedView.update(this.viewModel);
        if(this.bindedView.element!=null){
            this.element.replaceWith(this.bindedView.element);
            (<ComponentView<ViewModel>>this.bindedView.view).attachedToView();
        }
        (<any>this.mainElement).placeHolderFor = this.bindedView.element;
        // this.bindedView.element.append(...this.element.childNodes);
        (<ComponentView<ViewModel>>this.bindedView.view).append(...this.element.childNodes);
        this.element = this.bindedView.element;
        for(let i=0;i<this.parentAttributes.length;i++){
            let attr = this.parentAttributes.item(i);
            this.element.setAttribute(attr.name,attr.value);
        }
    } public get viewModel(): ViewModel { return this._viewModel;} private _viewModel: ViewModel;
    

    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.bindedView = new BindedView(this.prototype.binding.getViewSelectorFunction(view))
        this.mainElement = <Element>node;
        this.parentAttributes = this.element.attributes;
        let staticValue = this.bindingPrototype.getStaticValue();
        if(staticValue===undefined){
            this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'viewModel'))
        }else{
            this.viewModel = ComponentTagMappings.getComponent(staticValue)(view.dataContext);
            this.binding = Binder.createEmptyBinding();
        }
    }

    public release(){
        this.binding.release();
        this.bindedView.release();
    }
}